export default __webpack_public_path__ + "static/media/Panda_Inside.f2e0aaec.jpg";